import { captureException } from "@sentry/nextjs";
import { fromPromise } from "xstate";

import {
  submitTransunionFraudCheck,
  type TransunionFraudCheckParams,
} from "@/lib/services/transunionFraudCheck";

export class TransunionFraudCheckError extends Error {
  constructor(
    message: string,
    public readonly errorCode: string,
  ) {
    super(message);
    this.name = "TransunionFraudCheckError";
  }
}

const BLOCKING_RESULT = "D";
const BLOCKING_REASON = "PR: Owned Evidence Exists";

export const transunionFraudCheckActor = fromPromise<void, TransunionFraudCheckParams>(
  async ({ input }): Promise<void> => {
    let response;
    try {
      response = await submitTransunionFraudCheck(input);
    } catch (error) {
      // Network/API failures are fail-open — log and let the machine advance to submitting.
      captureException(error);
      return;
    }

    const { result, reason } = response?.localServerResponse ?? {};
    if (result === BLOCKING_RESULT && reason === BLOCKING_REASON) {
      throw new TransunionFraudCheckError("Transunion fraud check declined.", "TU_FAIL");
    }
  },
);
